import { FC } from 'react';
import { DrugItem, DrugReview } from 'src/api/types';
import { getCDNDrugImageURL } from 'src/utils/cdnStaticSourcesHelper';

interface Props {
  ssrDrugData: DrugItem;
  description: string;
  reviewsList: DrugReview[];
  metaUrl?: string;
}

const MetaProduct: FC<Props> = ({
  ssrDrugData,
  description,
  reviewsList,
  metaUrl
}) => {
  const isOutOfStock = !ssrDrugData?.minPrice && !ssrDrugData?.maxPrice;
  const reviewCount =
    ssrDrugData?.rateCount > 0 ? ssrDrugData.rateCount : undefined;

  const offersStockData = isOutOfStock
    ? {
        availability: 'https://schema.org/OutOfStock'
      }
    : {
        availability: 'https://schema.org/InStock',
        lowPrice: ssrDrugData?.minPrice.toString(),
        highPrice: ssrDrugData?.maxPrice.toString(),
        offerCount: ssrDrugData?.foundInBranchesCount
      };

  const reviews = reviewsList.map((review) => ({
    '@type': 'Review',
    name: review.userName,
    reviewBody: review.comment,
    datePublished: review.createDate,
    author: {
      '@type': 'Person',
      name: review.userName
    },
    publisher: {
      '@type': 'Organization',
      name: 'http://Likie.ua'
    }
  }));

  const metaProductJSON = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: ssrDrugData?.name,
    image: getCDNDrugImageURL(ssrDrugData?.id, 'M', 'png'),
    description,
    sku: ssrDrugData?.translitName,
    brand: {
      '@type': 'Brand',
      name: ssrDrugData?.tradeNameLink.translitName
    },
    offers: {
      '@type': 'AggregateOffer',
      priceCurrency: 'UAH',
      url: `https://api.likie.ua${metaUrl}`,
      ...offersStockData
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: ssrDrugData?.averageRate,
      bestRating: ssrDrugData?.bestRating,
      worstRating: ssrDrugData?.worstRating,
      reviewCount
    },
    review: reviews
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(metaProductJSON) }}
    />
  );
};

export default MetaProduct;
